import {QtyType} from '@/const/contract';

const STORAGE_BEFORE_V2 = 'common_contract_cache_before_v2';
const STORAGE_V2 = 'common_contract_cache_v2';

export function readQtyTypeBeforeV2() {
  let store = localStorage.getItem(STORAGE_BEFORE_V2);
  store = store ? JSON.parse(store) : store;
  return store ? store.qtyType : QtyType.Cont;
}

export function readQtyTypeV2() {
  let store = localStorage.getItem(STORAGE_V2);
  store = store ? JSON.parse(store) : store;
  return store ? store.qtyType : QtyType.Coin;
}
